<div class="flex flex-col">
    <!-- Header -->
    <div
        class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">
            <!-- <b>{{ 'payrollViews.changeGuide' | transloco }}</b> -->
            <b>{{data.row.displayName}} - Net4 ID: {{data.row.trabajadorNet4Id}} - {{data.period}} de {{data.year}} -
                Contrato {{data.row.laboralContratoId}}</b>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 flex flex-col bg-white dark:bg-gray-900 dark:bg-opacity-10">
        <div class="flex-0 px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <h2 class="text-lg font-semibold">{{ 'payrollViews.changeGuide' | transloco }}</h2>
            <p class="text-hint p-8 text-justify">
               {{ 'workerHourBag.changeGuideInfo' | transloco }}
            </p>
        </div>

        <div class="px-6 py-4 max-h-48 overflow-y-auto">
            <mat-radio-group [value]="workplaceNameSelected()" (change)="workplaceNameSelected.set($event.value)">
                @for (workplace of workplaceData; track workplace.workplaceCode) {
                <mat-radio-button [value]="workplace.workplaceCode" class="block mb-2">
                    {{workplace.name}} - Centro: {{ workplace.workplaceCode }} @if (workplace.forced) { ({{ 'workerHourBag.forcedWorkplace' | transloco }}) }
                </mat-radio-button>
                }
            </mat-radio-group>
        </div>

        <div class="flex flex-0 flex-row justify-end gap-2 px-6 py-4 dark:bg-black dark:bg-opacity-10">
            <button (click)="closeDialog()" mat-stroked-button>
                {{ 'cancel' | transloco }}
            </button>
            <button (click)="approve()" mat-flat-button color="primary">
                {{ 'accept' | transloco }}
            </button>
        </div>
